import { gql } from "@apollo/client";

export const CREATE_TOTP = gql`
  mutation createTotp {
    createTotp {
      id
      uri
    }
  }
`;

export const CONFIRM_TOTP = gql`
  mutation confirmTotp($input: ConfirmTotpInput!, $currentPassword: String!) {
    confirmTotp(input: $input, currentPassword: $currentPassword) {
      status
    }
  }
`;

export const REMOVE_TOTP = gql`
  mutation removeTotp($totpId: String!, $currentPassword: String) {
    removeTotp(totpId: $totpId, currentPassword: $currentPassword) {
      status
    }
  }
`;
